import useGenericSimulator from './useGenericSimulator';

const useSocket = () => {
    const { socket, setSocket } = useGenericSimulator();
    return { socket, setSocket };
};

export default useSocket;
